import client from '../client'

export async function placeVehicleForSale(body) {
  return client(`${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/Vehicles/PlaceForSale`, {
    headers: { 'Content-Type': 'application/json ' },
    method: 'POST',
    body: JSON.stringify({
      vehicleForSale: body,
    }),
  })
}
